import React, { useState } from "react";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { motion } from "framer-motion";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you for contacting us! We will get back to you soon.");
    setFormData({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero / Banner */}
      <motion.div
        className="relative h-[50vh] bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage: 'url("https://images.unsplash.com/photo-1501785888041-af3ef285b470")',
        }}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <motion.h1
          className="relative text-4xl md:text-5xl font-bold text-white text-center"
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          Contact Gorilland Travel
        </motion.h1>
      </motion.div>

      {/* Contact Section */}
      <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-12">
        {/* Contact Form */}
        <motion.div
          className="bg-white p-8 rounded-3xl shadow-lg"
          initial={{ x: -50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          <h2 className="text-3xl font-bold mb-6 text-[#002F1D]">Get in Touch</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#F59C10]"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#F59C10]"
            />
            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#F59C10]"
            />
            <textarea
              name="message"
              rows="6"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              required
              className="border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-[#F59C10]"
            ></textarea>
            <button
              type="submit"
              className="bg-[#002F1D] text-white py-3 rounded-lg font-semibold hover:bg-[#01462d] transition-all duration-300"
            >
              Send Message
            </button>
          </form>
        </motion.div>

        {/* Contact Info & Map */}
        <motion.div
          className="flex flex-col gap-8"
          initial={{ x: 50, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1 }}
        >
          {/* Info */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <motion.div whileHover={{ scale: 1.05 }} className="flex items-start gap-4">
              <FaPhoneAlt className="text-[#F59C10] mt-1" />
              <div>
                <h3 className="font-semibold text-lg">Phone</h3>
                <p>+256 772 642101</p>
                <p>+256 783 365384</p>
              </div>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} className="flex items-start gap-4">
              <FaEnvelope className="text-[#F59C10] mt-1" />
              <div>
                <h3 className="font-semibold text-lg">Email</h3>
                <p>info@gorillandtravelcare.com</p>
              </div>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} className="flex items-start gap-4">
              <FaMapMarkerAlt className="text-[#F59C10] mt-1" />
              <div>
                <h3 className="font-semibold text-lg">Address</h3>
                <p>Kampala, Uganda</p>
              </div>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }} className="flex items-start gap-4">
              <div className="flex flex-col">
                <h3 className="font-semibold text-lg">Follow Us</h3>
                <div className="flex gap-4 mt-1 text-xl text-gray-600">
                  <FaFacebook className="hover:text-[#1877F2] transition" />
                  <FaTwitter className="hover:text-[#1DA1F2] transition" />
                  <FaInstagram className="hover:text-[#E1306C] transition" />
                  <FaYoutube className="hover:text-[#FF0000] transition" />
                </div>
              </div>
            </motion.div>
          </div>

          {/* Map */}
          <motion.div
            className="w-full h-64 rounded-2xl overflow-hidden shadow-lg"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.925350014531!2d32.582520414288744!3d0.3475962140159366!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbfa0b9f3f53b%3A0x1f9247d89d11e8ee!2sKampala%2C%20Uganda!5e0!3m2!1sen!2sus!4v1692516800000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              allowFullScreen=""
              loading="lazy"
              title="Gorilland Travel Location"
            ></iframe>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Contact;
